import * as Sentry from '@sentry/react';

export const sessionStorageService = {
  get: <T>(key: string): T | null => {
    const value = sessionStorage.getItem(key);

    if (value === null) {
      return null;
    }

    try {
      return JSON.parse(value) as T;
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          key,
          value,
          message: `Error parsing sessionStorage key "${key}" with value "${value}" as JSON`,
        },
      });

      return null;
    }
  },
  getString: (key: string): string | null => {
    return sessionStorage.getItem(key);
  },
  set: (key: string, value: string): void => {
    sessionStorage.setItem(key, value);
  },
  remove: (key: string): void => {
    sessionStorage.removeItem(key);
  },
  clear: (): void => {
    sessionStorage.clear();
  },
};
